/**
 * ⚠️ 미리보기 전용 플래그 (의존성 없음 — 순환참조 방지용 분리 파일).
 * 켜면 실제 "일괄 등록하기" 버튼이 mock island를 구동(실 API 미호출).
 * 확인 후 반드시 false 로 되돌릴 것(기본 false → 실배포 무해). `?islandMock=1` 로도 켤 수 있음.
 */
export const ENABLE_ISLAND_MOCK = false; // 기본 off (실배포 무해). 미리보기는 ?islandMock=1

export const isIslandMockEnabled = (): boolean => {
  if (ENABLE_ISLAND_MOCK) return true;
  if (typeof window === 'undefined') return false;
  // playground(로그인·API 없는 체험 환경)에선 항상 mock으로 v3 진행/결과 UI를 그대로 구동
  if (window.location.pathname.includes('/playground')) return true;
  return new URLSearchParams(window.location.search).has('islandMock');
};
